module.exports = __webpack_public_path__ + "static/media/image-card-4.779db21a.png";